import * as React from 'react';

import { ILocalStore } from 'stores/interfaces';

const useLocalStore = <S extends ILocalStore = any>(
  creator: () => S,
  deps: React.DependencyList = []
): S => {
  const isFirstRender = React.useRef(true);

  const [store, setStore] = React.useState(creator);

  /** Если effect изменился, пересоздаем стор */
  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      return;
    }

    setStore(() => {
      return creator();
    });

    return () => {
      store.destroy();
    };
    // eslint-disable-next-line
  }, deps);

  React.useEffect(() => {
    return () => {
      store.destroy();
    };
  }, [store]);

  return store;
};

export default useLocalStore;
